export default __webpack_public_path__ + "static/media/back.988e1cf3.jpg";